import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "contact-info" }
const _hoisted_2 = { class: "contact--name" }
const _hoisted_3 = {
  key: 0,
  class: "contact--relationship"
}
const _hoisted_4 = {
  key: 1,
  class: "contact--address"
}
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = {
  key: 2,
  class: "contact--telephone"
}
const _hoisted_9 = { key: 3 }
const _hoisted_10 = { class: "contact--notes" }
const _hoisted_11 = { class: "description-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TranslatedText = _resolveComponent("TranslatedText")!
  const _component_Card = _resolveComponent("Card")!
  const _component_EmergencyContactForm = _resolveComponent("EmergencyContactForm")!
  const _component_DynamicList = _resolveComponent("DynamicList")!

  return (_openBlock(), _createBlock(_component_DynamicList, {
    items: _ctx.contacts,
    schema: _ctx.schema,
    buttonText: "models.emergency-contact.add",
    modalTitle: "models.emergency-contact.singular",
    newFunc: _ctx.createNewEmergencyContact,
    limit: _ctx.limit,
    readonly: _ctx.readonly,
    onSave: _ctx.handleSave,
    onDelete: _ctx.handleDelete
  }, {
    item: _withCtx(({ item, index }) => [
      _createVNode(_component_Card, {
        title: _ctx.getTitle(index, item.isPrimary)
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, _toDisplayString(item.name), 1),
            (item.relationship)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _createVNode(_component_TranslatedText, {
                    path: item.relationship
                  }, null, 8, ["path"])
                ]))
              : _createCommentVNode("", true),
            (item.address)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createElementVNode("div", null, _toDisplayString(item.address.line1), 1),
                  (item.address.line2)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(item.address.line2), 1))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", null, _toDisplayString(item.address.city), 1),
                  (item.address.county)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(item.address.county), 1))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", null, [
                    _createTextVNode(_toDisplayString(item.address.postcode) + " ", 1),
                    (item.address.country)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_7, " , " + _toDisplayString(item.address.country), 1))
                      : _createCommentVNode("", true)
                  ])
                ]))
              : _createCommentVNode("", true),
            _cache[0] || (_cache[0] = _createElementVNode("br", null, null, -1)),
            (item.telNumber)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, " +" + _toDisplayString(item.telCountryCode) + " " + _toDisplayString(item.telNumber), 1))
              : _createCommentVNode("", true),
            (item.notes)
              ? (_openBlock(), _createElementBlock("hr", _hoisted_9))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_10, _toDisplayString(item.notes), 1)
          ])
        ]),
        _: 2
      }, 1032, ["title"])
    ]),
    modalBody: _withCtx(({ update, formItem, errors }) => [
      _createElementVNode("p", _hoisted_11, [
        _createVNode(_component_TranslatedText, { path: "models.emergency-contact.description" })
      ]),
      _createVNode(_component_EmergencyContactForm, {
        contact: formItem,
        errors: errors,
        hidePrimary: _ctx.hidePrimary,
        telephoneRequired: _ctx.telephoneRequired,
        onUpdate: update
      }, null, 8, ["contact", "errors", "hidePrimary", "telephoneRequired", "onUpdate"])
    ]),
    _: 1
  }, 8, ["items", "schema", "newFunc", "limit", "readonly", "onSave", "onDelete"]))
}